import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'RETURNS', path: '/returns' },
    { name: 'PRIVACY', path: '/privacy' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-deepBlack/95 backdrop-blur-sm border-b border-gold/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex flex-col leading-tight cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/e071066a-4ba6-4679-a0bb-46b756ebdf2b.png" 
              alt="NEXTLIFE ASSET SALES LLC Logo" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm tracking-[2px] transition-all duration-300 relative whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-gold'
                    : 'text-white hover:text-gold'
                }`}
              >
                {link.name}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gold"></span>
                )}
              </Link>
            ))}
          </div>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:408-581-3979"
              className="text-gold text-sm flex items-center space-x-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              <span>408-581-3979</span>
            </a>
            <a
              href="mailto:edgarg@nextlifeasset.com"
              className="px-6 py-2.5 border-2 border-gold text-white rounded-full hover:bg-gold hover:text-black transition-all duration-300 text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gold text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-deepBlack/98 border-t border-gold/20">
          <div className="px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-sm tracking-[2px] py-2 transition-all duration-300 whitespace-nowrap ${
                  location.pathname === link.path ? 'text-gold' : 'text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-gold/20 space-y-3">
              <a
                href="tel:408-581-3979"
                className="text-gold text-sm flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                <span>408-581-3979</span>
              </a>
              <a
                href="mailto:edgarg@nextlifeasset.com"
                className="block text-center px-6 py-2.5 border-2 border-gold text-white rounded-full hover:bg-gold hover:text-black transition-all duration-300 text-sm font-semibold cursor-pointer whitespace-nowrap"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
